module.exports = __webpack_public_path__ + "static/media/path-sample.cb327131.png";